import React, { useState, useEffect } from "react";
import { Layout, BackTop, QRCode, message, Modal } from "antd";
import "./detail.scss";
import axiosInstance from "@/axios/axiosInstance";
import { ShareAltOutlined } from "@ant-design/icons"; // 引入分享图标
import { useLocation } from "react-router-dom";
import tool from "@/assets/tool";
import MyRichTextEditor from "@/assets/MyRichTextEditor";
import wx from "weixin-js-sdk";
const VideoDetailPage = () => {
  const [videoDetail, setDatali] = useState({});
  const [TutorialData, setTutorialData] = useState([]);
  const [user, setUser] = useState({});
  const [qrVisible, setQrVisible] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("");

  // const currentUrl = window.location.href; // 获取当前页面URL
  let location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const id = queryParams.get("id");
  const profilePictureUrl = queryParams.get("profilePictureUrl");
  const nickName = queryParams.get("nickName");
  useEffect(() => {
    if (id) {
      let user = {
        nickName: nickName,
        profilePictureUrl: profilePictureUrl,
      };
      setUser(user);
      fetchDetails(id);
      setupWechatConfig();
    }
  }, [id]); // 空依赖数组确保只运行一次// 空数组作为依赖项表示这个 effect 只在组件挂载时运行一次
  const setupWechatConfig = async () => {
    try {
      const currentUrl = window.location.href.split("#")[0];
      const response = await axiosInstance.get(
        `/account/wxlogin?url=${encodeURIComponent(currentUrl)}`
      );
      const config = response.data.data;
      setCurrentUrl(currentUrl);

      wx.config({
        debug: false, // 开发调试时可以设为 true
        appId: config.appId,
        timestamp: config.timestamp,
        nonceStr: config.nonceStr,
        signature: config.signature,
        jsApiList: [
          "updateAppMessageShareData",
          "updateTimelineShareData",
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
        ],
      });

      wx.ready(() => {
        // 在wx.ready后立即设置分享内容
        const shareData = {
          title: videoDetail.title || "渐风AI", // 使用文章标题
          desc: videoDetail.content
            ? videoDetail.content.replace(/<[^>]+>/g, "").slice(0, 100) + "..."
            : "渐风AI是一个专业的人工智能学习平台", // 使用文章内容的前100字符
          link: currentUrl, // 当前页面链接
          imgUrl: "https://www.aijfeng.com/share-logo.jpg", // 分享图标
          success: function () {
            console.log("分享设置成功");
          },
          fail: function (res) {
            console.error("分享设置失败:", res);
          },
        };
        // 新版接口
        wx.updateAppMessageShareData(shareData);
        wx.updateTimelineShareData(shareData);

        // 旧版接口兼容
        wx.onMenuShareAppMessage({
          ...shareData,
          type: "link",
        });
        wx.onMenuShareTimeline({
          title: shareData.title,
          link: shareData.link,
          imgUrl: shareData.imgUrl,
        });
      });

      wx.error((res) => {
        console.error("微信配置失败:", res);
      });
    } catch (error) {
      console.error("获取微信配置失败:", error);
    }
  };
  // 在文章数据更新后重新设置分享配置
  useEffect(() => {
    if (videoDetail.title && currentUrl) {
      setupWechatConfig();
    }
  }, [videoDetail, currentUrl]);

  useEffect(() => {
    if (videoDetail.title) {
      // 更新文档标题
      document.title = `${videoDetail.title} - 渐风AI`;

      // 更新 meta 标签
      const metaTags = {
        "og:title": videoDetail.title,
        "og:description":
          videoDetail.content?.replace(/<[^>]+>/g, "").slice(0, 200) || "",
        "og:url": window.location.href,
      };

      Object.entries(metaTags).forEach(([property, content]) => {
        const meta = document.querySelector(`meta[property="${property}"]`);
        if (meta) {
          meta.setAttribute("content", content);
        }
      });
    }
  }, [videoDetail]);
  // 处理分享按钮点击
  const handleShare = () => {
    const shareData = {
      title: videoDetail.title,
      desc: videoDetail.content?.replace(/<[^>]+>/g, "").slice(0, 100) + "...",
      link: currentUrl,
      imgUrl: "https://www.aijfeng.com/share-logo.jpg",
    };

    console.log("点击分享按钮，分享数据:", shareData); // 调试用

    wx.ready(() => {
      wx.updateAppMessageShareData(shareData);
      wx.updateTimelineShareData(shareData);
    });

    setQrVisible(true);
  };
  const getTutorialData = async (b) => {
    try {
      const labelParam = b.label;
      const response = await axiosInstance.get(
        `/tutorial/page/list?label=${labelParam}&title=${""}`
      );
      setTutorialData(response.data.data);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };
  const fetchDetails = async (id) => {
    try {
      const response = await axiosInstance.get(
        `tutorial/page/detail?tutorialId=${id}`
      );
      setDatali(response.data.data);
      getTutorialData(response.data.data);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  // 复制链接到剪贴板
  const copyLink = () => {
    navigator.clipboard
      .writeText(currentUrl)
      .then(() => {
        message.success("链接已复制到剪贴板");
      })
      .catch(() => {
        message.error("复制失败，请手动复制");
      });
  };
  return (
    <Layout className="tutor_datail">
      <div className="videolist-hea">
        <div className="name">教程文章</div>
        <div></div>
        <div className="name name_titke">
          {videoDetail.title}
          <ShareAltOutlined
            className="share-icon"
            onClick={(e) => {
              e.stopPropagation();
              handleShare(videoDetail);
            }}
          />
        </div>
        <div className="name_time">
          {user.nickName || tool.hideMiddleFour(videoDetail.phone)}
          <span>{videoDetail.updateTime}</span>
          <span>来源为用户上传，如有侵权请申诉</span>
        </div>
      </div>
      <div className="turor_content">
        {/* <div className="content">
          <div
            dangerouslySetInnerHTML={{ __html: videoDetail.content }}
            className="ql-editor"
          />
        </div> */}
        <div className="ql-editor">
          <MyRichTextEditor value={videoDetail.content} />
        </div>
        <div className="right">
          {/* 作者信息 */}
          <div className="author-info">
            <img
              src={`/file/${videoDetail.profilePictureUrl}`}
              alt="author"
              className="avatar"
            />
            <span>
              {videoDetail.nickName || tool.hideMiddleFour(videoDetail.phone)}
            </span>
            <div className="info">
              <div className="name">{videoDetail.createUserName}</div>
              <div className="desc">{}</div>
            </div>
          </div>

          {/* 相关视频列表 */}
          <div className="related-list">
            <div className="section-title">相关推荐</div>
            {TutorialData.map((tutorial, index) => (
              <div
                key={tutorial.tutorialId}
                className="related-item"
                onClick={() => {
                  const params = new URLSearchParams({
                    id: tutorial.tutorialId,
                    profilePictureUrl: tutorial.profilePictureUrl,
                    nickName: tutorial.nickName,
                  });
                  const url = `/tutorial_detail?${params.toString()}`;
                  window.open(url, "_blank"); // 在新窗口或新标签页中打开
                }}
              >
                <div className="info">
                  <div className="title">{tutorial.title}</div>
                  <div className="meta">
                    {/* <span>{tutorial.author}</span> */}
                    {/* <span>{tutorial.views}次观看</span> */}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* 广告区域 */}
          <div className="ad-section">{/* 广告内容 */}</div>
        </div>
      </div>
      <BackTop />
      <Modal
        title="分享到微信"
        open={qrVisible}
        onCancel={() => setQrVisible(false)}
        footer={null}
        className="share-modal"
      >
        <div className="share-content">
          <div className="qr-section">
            <QRCode value={currentUrl} size={200} />
            <p>微信扫码分享</p>
          </div>
          <div className="share-options">
            <div className="share-button" onClick={copyLink}>
              复制链接
            </div>
          </div>
          <div className="share-tips">
            <p>提示：</p>
            <p>1. 使用微信扫描二维码</p>
            <p>2. 点击右上角菜单</p>
            <p>3. 选择"分享给朋友"或"分享到朋友圈"</p>
          </div>
        </div>
      </Modal>
    </Layout>
  );
};

export default VideoDetailPage;
